import classNames from 'classnames';
import { Row } from 'components/tables/accordion-table.js';
import { ITideMarkerData, TidePeak } from 'types/tides.js';
import { predicatePopulatedStringOrNumber } from 'utilities/isType.js';

const TideRowContent = ({ tide }: { tide: ITideMarkerData | null }) => {
  if (tide) {
    const hasHeight = predicatePopulatedStringOrNumber(tide.height);
    return (
      <>
        <td>
          <small className="u-textBold">{tide.time}</small>
        </td>
        <td>{hasHeight && <small className="u-block"> {tide.height}m </small>}</td>
      </>
    );
  }
  // Empty tide cells
  return (
    <>
      <td>
        <small>-</small>
      </td>
      <td className="tides-small">
        <small>-</small>
      </td>
    </>
  );
};

export const TideRow = ({ tide, head }: { tide: ITideMarkerData | null; head: string }) => {
  const isLowTide = head === TidePeak.Low;

  return (
    <Row classes={classNames({ 'u-textGrey': isLowTide })}>
      <th className="h4">{head}</th>
      <TideRowContent tide={tide} />
    </Row>
  );
};
